<nav #navbar class="navbar navbar-expand-lg navbar-transparent navbar-light" 
[ngClass]="{'nav-fixed1': !isHidenSideBar, 'nav-fixed2': isHidenSideBar}">
  <div class="container-fluid pl-0 pr-0">

    <div class="navbar-wrapper">
      <div class="navbar-minimize" matTooltip="Cerrar/Abrir menú" [matTooltipPosition]="'right'">
        <button mat-raised-button (click)="minimizeSidebar()" 
          class="btn btn-just-icon btn-white btn-fab btn-round realize-button-navbar">
          <i class="material-icons text_align-center visible-on-sidebar-regular realize-icon-navbar">
            more_vert</i>
          <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini realize-icon-navbar">
            view_list</i>
        </button>
      </div>

      <div class="navbar-minimize" matTooltip="Regresar" [matTooltipPosition]="'right'">
        <button mat-raised-button (click)="goBack()"
          class="btn btn-just-icon btn-white btn-fab btn-round realize-button-navbar">
          <i class="material-icons text_align-center pl-2 realize-icon-navbar">
            arrow_back_ios
          </i>
        </button>
      </div>

      <div class="navbar-minimize" matTooltip="Notificaciones" [matTooltipPosition]="'right'">
        <button mat-raised-button (click)="goNotify()"
          class="btn btn-just-icon btn-white btn-fab btn-round realize-button-navbar">
          <i class="material-icons text_align-center pl-0 realize-icon-navbar">
            notifications
          </i>
          <!-- Indicador de notificaciones -->
          <span *ngIf="notificationCount > 0" class="notification-badge">
            {{ notificationCount }}
          </span>
          <span *ngIf="notificationCount === 0" class="notification-dot"></span>
        </button>
      </div>


    </div>

    <button mat-raised-button type="button" (click)="sidebarToggle()" matTooltip="Cerrar/Abrir menú"
      class="navbar-toggler btn-no-ripple btn btn-just-icon btn-white btn-fab btn-round mr-2 realize-button-navbar">
      <span class="sr-only">Toggle navigation</span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>      
    </button>

    <button mat-raised-button type="button" (click)="goBack()" matTooltip="Regresar"
      class="navbar-toggler btn-no-ripple btn btn-just-icon btn-white btn-fab btn-round mr-2 realize-button-navbar">
      <i class="material-icons text_align-center pl-2 realize-icon-navbar">
        arrow_back_ios</i>
    </button>

    <button mat-raised-button type="button" (click)="goNotify()" matTooltip="Notificaciones"
      class="navbar-toggler btn-no-ripple btn btn-just-icon btn-white btn-fab btn-round mr-2 realize-button-navbar">
      <i class="material-icons text_align-center pl-0 realize-icon-navbar">
        notifications</i>
      <!-- Indicador de notificaciones -->
      <span *ngIf="notificationCount > 0" class="notification-badge">
        {{ notificationCount }}
      </span>
      <span *ngIf="notificationCount === 0" class="notification-dot"></span>
    </button>

    
    
    <div class="collapse navbar-collapse justify-content-end" id="navigation">
      <!-- <form class="navbar-form">
        <div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Search...">
          <button mat-raised-button type="submit" class="btn btn-white btn-round btn-just-icon">
            <i class="material-icons">search</i>
            <div class="ripple-container"></div>
          </button>
        </div>
      </form> -->
      <!-- <ul class="navbar-nav"> -->
        <!-- <li class="nav-item">
          <a class="nav-link" href="#pablo">
            <i class="material-icons">dashboard</i>
            <p>
              <span class="d-lg-none d-md-block">Stats</span>
            </p>
          </a>
        </li> -->
        <!-- <li class="nav-item dropdown">
          <a class="nav-link" href="#pablo" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="material-icons">notifications</i>
            <span class="notification">5</span>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
            <a class="dropdown-item" href="#">Mike John responded to your email</a>
            <a class="dropdown-item" href="#">You have 5 new tasks</a>
            <a class="dropdown-item" href="#">You're now friend with Andrew</a>
            <a class="dropdown-item" href="#">Another Notification</a>
            <a class="dropdown-item" href="#">Another One</a>
          </div>
        </li> -->

        <!-- <li class="nav-item">
          <a href="#" class="nav-link text-white" id="navbarDropdownProfileLink" data-toggle="dropdown" 
          aria-haspopup="true" aria-expanded="false">
            <i class="material-icons">account_circle</i>
            <p>
              <span class="d-lg-none d-md-block">Account</span>
            </p>
          </a>
         
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownProfileLink">
            <a class="dropdown-item cursor" (click)="openConfig()">
              <i class="material-icons">settings</i>
              Configurar Ubicación
            </a>
            <a class="dropdown-item cursor" (click)="logOut()">
                <img src="/assets/images/logout.svg">Salir
            </a>
          </div>
        </li> -->


      <!-- </ul> -->
    </div>

  </div>
</nav>
